const catalogButtons = document.querySelectorAll("[data-catalog-btn]")
const catalogCarousel = document.querySelector("[data-catalog-carousel")
var carouselItemWidth = catalogCarousel.firstElementChild.getBoundingClientRect().width + 32
const vidButtons = document.querySelectorAll("[data-button]")
const slideElements = document.querySelectorAll("[data-video-container]")
var vidIDX = 0
var carouselOffset = carouselItemWidth * -1
var transitionEnd
let direction


if(screenWidth <= 1545) {
    catalogCarousel.style.transform = `translateX(${carouselOffset}px)`
    moveCatalog()
}

catalogCarousel.addEventListener("transitionend", (event) => {
    if(event.propertyName === "transform") {
        event.target.lastElementChild.setAttribute("aria-hidden", "false")
            event.target.firstElementChild.setAttribute("aria-hidden", "false")
            event.target.lastElementChild.setAttribute("tabindex", "0")
            event.target.firstElementChild.setAttribute("tabindex", "0")
        event.target.classList.toggle("no-transition")
        if(direction === 1)
            event.target.prepend(event.target.lastElementChild)
        else if(direction === -1)
            event.target.appendChild(event.target.firstElementChild)
        event.target.style.transform = `translateX(${carouselOffset}px)`
        setTimeout(() => {
            event.target.classList.toggle("no-transition")
            transitionEnd = true
        }, 100);

        setTimeout(() => {
            event.target.lastElementChild.setAttribute("aria-hidden", "true")
            event.target.firstElementChild.setAttribute("aria-hidden", "true")
            event.target.lastElementChild.setAttribute("tabindex", "-1")
            event.target.firstElementChild.setAttribute("tabindex", "-1")
        }, 500)

    }
})

window.addEventListener("resize", () => {
    catalogCarousel.classList.toggle("no-transition")
    carouselItemWidth = catalogCarousel.firstElementChild.getBoundingClientRect().width + 32
    carouselOffset = carouselItemWidth * -1
    catalogCarousel.style.transform = `translateX(${carouselOffset}px)`
    if(screenWidth <= 1545)
        moveCatalog()
    else
        catalogCarousel.style.transform = `translateX(0px)`
    setTimeout(() => {
        catalogCarousel.classList.toggle("no-transition")
    }, 500);
})

catalogButtons.forEach(button => {
    button.addEventListener("click", () => {
        var btnName = button.getAttribute("data-catalog-btn")
        if(btnName === "prev" && transitionEnd === true || transitionEnd === undefined) {
            transitionEnd = false
            direction = -1
            catalogCarousel.style.transform = `translateX(${carouselOffset - carouselItemWidth}px)`
        } else if(btnName === "next" && transitionEnd === true || transitionEnd === undefined) {
            transitionEnd = false
            direction = 1
            catalogCarousel.style.transform = `translateX(${0}px)`
        }
    })
})

function moveCatalog() {
    var temp = catalogCarousel.children[0]
    var middleIdx = Math.ceil(catalogCarousel.children.length/2)
    Array.from(catalogCarousel.children).forEach((child, idx) => {
        if(child.classList.contains("main-catalog") && idx != 0) {
            if(screenWidth <= 1000)
                child.parentNode.insertBefore(child, catalogCarousel.children[1])
            else if(screenWidth > 1000 && idx != middleIdx) {
                child.parentNode.insertBefore(child, catalogCarousel.children[middleIdx])
            }
        }
    })
}

vidButtons.forEach(button => {
    button.addEventListener("click", () => {
        var btnName = button.getAttribute("data-button")
        var currentVid = slideElements[vidIDX]

        currentVid.classList.remove("visible")
        setTimeout(() => {
            currentVid.classList.add("hidden")
        }, 500)
        if(btnName === "next") {
            if(++vidIDX >= slideElements.length)
                vidIDX = 0
            var nextVid = slideElements[vidIDX]

            nextVid.classList.remove("hidden")
            setTimeout(() => {
                nextVid.classList.add("visible")
            }, 100)
        } else if(btnName === "prev") {
            if(--vidIDX < 0)
                vidIDX = slideElements.length - 1
            var prevVid = slideElements[vidIDX]

            prevVid.classList.remove("hidden")
            setTimeout(() => {
                prevVid.classList.add("visible")
            }, 100)
        }
    })
})